import { render, staticRenderFns } from "./indexModelFive.vue?vue&type=template&id=ed869306&scoped=true&"
import script from "./indexModelFive.vue?vue&type=script&lang=js&"
export * from "./indexModelFive.vue?vue&type=script&lang=js&"
import style0 from "./indexModelFive.vue?vue&type=style&index=0&id=ed869306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed869306",
  null
  
)

export default component.exports